import React, { useState, useEffect, useCallback } from "react";
import StepUpMfaModal from "./seguranca/StepUpMfaModal";
import { stepUpEvents } from "../utils/stepUpEvents";

const StepUpHandler = () => {
  const [showModal, setShowModal] = useState(false);
  const [bucket, setBucket] = useState("security");

  useEffect(() => {
    const unsubscribe = stepUpEvents.on(
      "step-up-required",
      ({ bucket: reqBucket }) => {
        setBucket(reqBucket);
        setShowModal(true);
      }
    );

    return () => unsubscribe();
  }, []);

  const handleSuccess = useCallback(() => {
    setShowModal(false);
    stepUpEvents.resolveStepUp();
  }, []);

  const handleCancel = useCallback(() => {
    setShowModal(false);
    stepUpEvents.rejectStepUp();
  }, []);

  return (
    <StepUpMfaModal
      show={showModal}
      onHide={handleCancel}
      onSuccess={handleSuccess}
      bucket={bucket}
    />
  );
};

export default StepUpHandler;
